import React, { useMemo, useState, useEffect, useRef } from 'react';
import '../styles/CompCardMap.css';
import { GoogleMap } from '@react-google-maps/api';
import { Marker } from './';
import { House, MapBubble } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function CompCardMap(props) {
    const isMapLoaded = props.isMapLoaded;
    const isMapActive = props.isMapActive;
    const comp = props.comp;
    const subjectProperty = props.subjectProperty;
    const distance = comp.compDetails.distanceMiles;
    const bestComp = props.bestComp;
    const zoom = distance < 0.5 ? 15 : distance < 0.75 ? 14 : 13;
    const centre = ({ lat: subjectProperty.addressDetails.latitude, lng: subjectProperty.addressDetails.longitude });
    const [rawMap, setRawMap] = useState(null);
    const directionsServiceRef = useRef(null);
    const directionsRendererRef = useRef(null);

	const options = {
        disableDefaultUI: false,
        scrollwheel: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapId: JSON.parse(process.env.REACT_APP_COMPS_DETAIL_MAP_ID).key
    };

    // Coordinates for the two markers
    const startPosition = {
        lat: subjectProperty.addressDetails.latitude,
        lng: subjectProperty.addressDetails.longitude
    };

    const onLoad = (mapInstance) => {
        setRawMap(mapInstance);
    };

    // Whenever clickedComp or showMapDirections changes, route or clear
    useEffect(() => {
        if (
            directionsServiceRef.current &&
            directionsRendererRef.current &&
            rawMap &&
            distance > 0.1
        ) {
        
            const originalPosition = {
                lat: subjectProperty.addressDetails.latitude,
                lng: subjectProperty.addressDetails.longitude
            };
            // We have all conditions to request directions
            const destination = {
                lat: comp.addressDetails.latitude,
                lng: comp.addressDetails.longitude
            };
            directionsServiceRef.current.route(
                {
                    origin: originalPosition,
                    destination,
                    travelMode: "DRIVING"
                },
                (result, status) => {
                    if (status === "OK") {
                        // Attach our single DirectionsRenderer to the map
                        directionsRendererRef.current.setMap(rawMap);
                        // Updating directions automatically replaces any previous route
                        directionsRendererRef.current.setDirections(result);
                    } else {
                        console.error("Directions request failed:", status);
                    }
                }
            );
        } 
        else if (directionsRendererRef.current) {
            // If user hides directions or there is no clickedComp, remove from map
            directionsRendererRef.current.setMap(null);
            directionsRendererRef.current.setDirections({ routes: [] });
        }
    }, [subjectProperty.addressDetails.latitude, subjectProperty.addressDetails.longitude, rawMap, comp.addressDetails.latitude, comp.addressDetails.longitude, distance]);

    // Create the DirectionsService and DirectionsRenderer once
    useEffect(() => {
        if (window.google && !directionsServiceRef.current && !directionsRendererRef.current) {
            directionsServiceRef.current = new window.google.maps.DirectionsService();
            directionsRendererRef.current = new window.google.maps.DirectionsRenderer({
                polylineOptions: {
                    strokeColor: colour.gray07,
                    strokeOpacity: 0.8,
                    strokeWeight: 6
                },
                markerOptions: {
                icon: {
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: colour.gray07,
                    fillOpacity: 1,
                    strokeWeight: 0
                }
                },
                preserveViewport: true
            });
        }
    }, []);

    const compsMarker = useMemo(() => {
        if (!rawMap || !comp) return null; // Ensure map and comp exist

        return {
                comp,
                position: {
                    lat: comp.addressDetails.latitude,
                    lng: comp.addressDetails.longitude
                }
            };
    }, [comp, rawMap]);

    return (
        isMapLoaded === true && isMapActive === true ?
        <GoogleMap
            zoom={zoom}
            center={centre}
            mapContainerClassName="comp-card-map-container"
            options={options}
            onLoad={onLoad}
        >
            {
                rawMap !== null &&
                <Marker
                    key={comp.uniqueIds.zillowId}
                    map={rawMap}
                    position={compsMarker.position}
                    onClick={() => null}
                >
                    <div className="relative-container">
                        <MapBubble
                            className=""
                            fill={bestComp === true ? colour.jade01 : colour.gray02}
                            stroke={bestComp === true ? colour.jade02 : colour.gray03}
                            strokeWidth={"0.5"}
                        />
                        <House
                            fill={bestComp === true ? colour.jade03 : colour.gray04}
                            className="cluster-map-house-icon"
                        />
                    </div>
                </Marker>
            }
            {
                rawMap &&
                <Marker
                    map={rawMap}
                    position={startPosition}
                    onClick={() => null}
                >
                    <div className="relative-container">
                        <MapBubble
                            className=""
                            fill={colour.gray07}
                            stroke={colour.gray00}
                            strokeWidth={"0.5"}
                        />
                        <House
                            fill={colour.gray00}
                            className="comps-map-house-icon"
                        />
                    </div>
                </Marker>
            }
        </GoogleMap>
        :
        <div className="comp-card-map-placeholder">

        </div>
    )
};

export default CompCardMap;